export enum EmailsColumnSizes {
  Name = 66,
  Format = 21,
  Size = 9,
}
